export * from "./documentPlaceholderBuilder";
export * from "./placeholders";
export * from "./types";

// @ts-ignore import.meta is problematic
export const FontUrl = new URL("./HelveticaWorld-Regular.ttf", import.meta.url);
export const FontName = "Helvetica World";
export const Font = FontUrl.href;
